// @flow

export type Url = string;
export type ResourcePublicId = string | Url;
export type ResourceAccessType = 'fetch' | 'upload' | 'youtube';
export type ResourceType = 'image' | 'video';

export type Resource = {|
  publicId: ResourcePublicId,
  accessType: ResourceAccessType,
  resourceType: ResourceType,
|};

const UploadedResourceRegex = /(https?:)?\/\/(res.cloudinary.com\/powerreviews|media.powerreviews.com)\/(image|video)\/upload\/(v[0-9]{10,}\/){0,1}/g;
const SupportedImageFileTypesRegex = /\.(jpg|jpe|jpeg|jpc|jp2|j2k|wdp|jxr|hdp|png|gif|webp|bmp|tif|tiff)$/g;
const SupportedVideoFileTypesRegex = /\.(mp4|webm|flv|mov|ogv|3gp|3g2|wmv|mpeg|flv|mkv|avi)$/g;
const parseUploadedUrl = url => {
  const p = url.split(UploadedResourceRegex).pop(); //TODO

  return p
    .replace(SupportedImageFileTypesRegex, '')
    .replace(SupportedVideoFileTypesRegex, '');
};
const escapeFetchUrl = (url: string) => {
  return url.replace(/\?/g, '%3F');
};

export const createUploadedImageResource = (url: Url): Resource => {
  const publicId = parseUploadedUrl(url);

  return {
    accessType: 'upload',
    resourceType: 'image',
    publicId,
  };
};

export const createUploadedVideoResource = (url: Url): Resource => {
  const publicId = parseUploadedUrl(url);

  return {
    accessType: 'upload',
    resourceType: 'video',
    publicId,
  };
};

export const createProductImageResource = (url: Url): Resource => {
  return {
    accessType: 'fetch',
    resourceType: 'image',
    publicId: escapeFetchUrl(url),
  };
};

export const YoutubeRegex = /(youtube.com\/(v\/|watch\?v=)|(youtu\.be\/))/i;
export const createYoutubeVideoResource = (url: Url): Resource => {
  const publicId = url.split(YoutubeRegex).pop();

  return {
    accessType: 'youtube',
    resourceType: 'image',
    publicId,
  };
};



// WEBPACK FOOTER //
// ./src/lib/pwr-cloudinary/Resource.js